'use strict';//Indicating browser should run only in java script mode

angular.module('EMR.Admin').service('PatientMedicationTrackerCommonService', ['CommonPostService', function (CommonPostService) {

    /**
   * This method is used to GET LOW INVENTORY MEDICATION COUNT FOR INBOX
   * @author : vineel barma
   * @since : 09/3/2019
   */
    this.GetLowMedicationInventoryAlertCount1 = function (postData) {
        // ASSIGNING THE PRACTIC EMODEL
        postData.practicemodel = EMRPracticeModel;

        return CommonPostService.httpPostData('POST', `${CommonPostService.EHRPatientMedicationInventory()}GetPatientMedicationTrackersAlertCount`, postData).then(
            function (result) {
                return result;
            });
    };

     //*******PURPOSE: THIS METHOD IS USED TO GET RULES SETTINGS CUSTOMIZATIONS PERMISSIONS INFO
    this.rulesGetRulesJsonInfoBasedOnIdenittyColumnValuetoView = function (postData) {
      postData.practicemodel = EMRPracticeModel;
      postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
      return CommonPostService.httpPostData('POST', `${CommonPostService.EHR_JSON_Rules_Settings_Customizations_Permissions_API()}GetRulesSettingsCustomizationsPermissionsInfo`, postData).then(
        function (result) {
          return result;
        });
    };


}]);